import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Colors } from '@adsk/bim360-matrix-react-helpers/es/consts';

import './_Pill.scss';

import objectValues from '@adsk/bim360-matrix-react-helpers/es/objectValues';

/**
 * A simple Pill component that renders a pill based on a className/style/color passed
 */
const Pill = props => {
  const pillProps = {};
  pillProps.className = classNames('Pill', props.className, {
    [`Pill--${props.color}`]: props.color
  });
  if (props.style) pillProps.style = props.style;

  return <span {...pillProps}>{props.label}</span>;
};

Pill.Colors = Colors;

Pill.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  label: PropTypes.string.isRequired,
  /**
   * The color of the pill.
   */
  color: PropTypes.oneOf(objectValues(Pill.Colors))
};

export default Pill;
